import { useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { trackEvent } from '@/lib/analytics';

export const useDashboardActions = () => {
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleRunClick = (id: string) => {
    trackEvent('run_view', { runId: id });
    navigate(`/runs/${id}`);
  };

  const handleAlertClick = (id: string) => {
    trackEvent('alert_view', { alertId: id });
    navigate(`/alerts/${id}`);
  };
  
  const handleAcknowledgeAlert = (id: string) => {
    trackEvent('alert_acknowledged', { alertId: id });
    toast({
      title: 'Alert acknowledged',
      description: `Alert ${id} has been acknowledged`,
    });
  };
  
  const handleCreateTicket = (id: string) => {
    trackEvent('ticket_created', { alertId: id });
    toast({
      title: 'Creating ticket',
      description: 'Redirecting to Jira to create a ticket',
    });
    // In a real app, this would open Jira or call an API
  };

  return {
    handleRunClick,
    handleAlertClick,
    handleAcknowledgeAlert,
    handleCreateTicket
  };
};

export default useDashboardActions;
